import { LoginComponent } from './auth/login/login.component';
import { WebUtils } from './utils/web.utils';
var CustomReuseStrategy = /** @class */ (function () {
    function CustomReuseStrategy() {
        this.DEFAULT_CACHED_ROUTES = ['discover', 'discover/posts', 'discover/influencers'];
        this.routesToCache = ['discover', 'discover/posts', 'discover/influencers'];
        this.storedRouteHandles = new Map();
        this.currentActiveCompany = Number(WebUtils.extractQueryParams('activeAccount'));
    }
    CustomReuseStrategy.prototype.updateRouteToCache = function (route) {
        if (this.routesToCache.indexOf(route) < 0) {
            this.routesToCache.push(route);
        }
    };
    CustomReuseStrategy.prototype.resetCachedRoutes = function () {
        this.routesToCache = [];
        (_a = this.routesToCache).push.apply(_a, this.DEFAULT_CACHED_ROUTES);
        var _a;
    };
    // Decides if the route should be stored
    CustomReuseStrategy.prototype.shouldDetach = function (route) {
        if (!route.routeConfig) {
            return false;
        }
        var pathDetails = this.getResolvedUrl(route);
        return this.routesToCache.indexOf(pathDetails) > -1;
    };
    // Store the information for the route we're destructing
    CustomReuseStrategy.prototype.store = function (route, handle) {
        if (!route.routeConfig) {
            return;
        }
        var pathDetails = this.getResolvedUrl(route);
        this.storedRouteHandles.set(pathDetails, handle);
    };
    // Return true if we have a stored route object for the next route
    CustomReuseStrategy.prototype.shouldAttach = function (route) {
        if (!route.routeConfig) {
            return false;
        }
        if (route.component === LoginComponent) {
            this.storedRouteHandles = new Map();
            return false;
        }
        var activeCompany = Number(WebUtils.extractQueryParams('activeAccount'));
        if (activeCompany && this.currentActiveCompany !== activeCompany) {
            this.storedRouteHandles = new Map();
            this.currentActiveCompany = activeCompany;
            return false;
        }
        var pathDetails = this.getResolvedUrl(route);
        return this.storedRouteHandles.has(pathDetails);
    };
    // If we returned true in shouldAttach(), now return the actual route data for restoration
    CustomReuseStrategy.prototype.retrieve = function (route) {
        if (!route.routeConfig) {
            return null;
        }
        var pathDetails = this.getResolvedUrl(route);
        return this.storedRouteHandles.get(pathDetails);
    };
    // Reuse the route if we're going to and from the same route
    CustomReuseStrategy.prototype.shouldReuseRoute = function (future, curr) {
        return future.routeConfig === curr.routeConfig;
    };
    CustomReuseStrategy.prototype.getResolvedUrl = function (route) {
        return route.pathFromRoot
            .filter(function (v) { return v.url.length > 0; })
            .map(function (v) { return v.url.map(function (segment) { return segment.toString(); }).join('/'); })
            .join('/');
    };
    return CustomReuseStrategy;
}());
export { CustomReuseStrategy };



// WEBPACK FOOTER //
// ./src/app/routing.ts.pre-build-optimizer.js